var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.list),function(item,index){return _c('div',{key:index},[(item.name===_vm.id)?[_c('product-banner',{attrs:{"list":item}}),_c('product-detail',{attrs:{"display":item.display}})]:_vm._e()],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }